var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',_vm._g(_vm._b({class:{'d-inline-flex': _vm.flex },attrs:{"color":_vm.color,"dark":""}},'v-toolbar',_vm.$attrs,false),_vm.$listeners),[_c('v-toolbar-title',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }